import { useMutation, useQueryClient } from '@tanstack/react-query';

import { addMedia } from '../../apiClient';
import { notifications } from '@mantine/notifications';
import { useEntityQueryUpdate } from '../../../hooks/useEntityQueryUpdate';

const useAddMedia = () => {
    const entityUpdater = useEntityQueryUpdate();
    const queryClient = useQueryClient();

    const addMediaMutation = useMutation({
        mutationKey: 'add_media',
        mutationFn: (formData) => addMedia(formData),
        onSuccess: (data) => {
            entityUpdater(
                [['campaign_medias'], ['campaign_media', data.id]],
                data
            );
            queryClient.invalidateQueries({
                queryKey: ['media_group', data.groupId],
                exact: true,
            });
            notifications.show({
                title: 'Success',
                message: 'Successfully updated media',
                color: 'green',
            });
        },
        onError: (error) => {
            notifications.show({
                title: 'Error',
                message: error.message,
                color: 'red',
            });
        },
    });
    return addMediaMutation;
};
export default useAddMedia;
